import {
	IPOSummaryGridDetail,
	IPurchaseOrderStatus,
	IPurchaseOrderNumber,
} from "models/ContractManagement/PurchaseOrderDetailModel";
import { TableFilterModel } from "models/TableFilterModel";
import { ITableNumberColumnFilter } from "models/TableNumberColumnFilter";
import { BaseService } from "./base.service";

class PurchaseOrderServiceInternal extends BaseService {
	getPurchaseOrderList = async (
		model: TableFilterModel
	): Promise<IPOSummaryGridDetail[]> =>
		this.callApi<IPOSummaryGridDetail[]>(
			`PurchaseOrder/GetPurchaseOrderList`,
			"POST",
			undefined,
			model
		);

	getPurchaseNumberList = async (
		model: ITableNumberColumnFilter
	): Promise<IPurchaseOrderNumber[]> =>
		this.callApi<IPurchaseOrderNumber[]>(
			`PurchaseOrder/GetPurchaseOrderNumberList`,
			"POST",
			undefined,
			model
		);

	getPurchaseOrderStatusList = async (): Promise<IPurchaseOrderStatus[]> =>
		this.callApi<IPurchaseOrderStatus[]>(
			`PurchaseOrderStatus/GetPurchaseOrderStatusList`,
			"GET"
		);
}

export const PurchaseOrderService = new PurchaseOrderServiceInternal();
